import castIn from './cast-in.jpg';
import postFixed from './post-fixed.jpg';

export default {
  'Cast In': castIn,
  'Post Fixed': postFixed,
};
